import React from 'react'
import PropTypes from 'prop-types'

import FormManager from 'src/core/gd-form/common/form-manager'
import Form from 'src/core/gd-form/form/form-modal-new/form-modal-new'
// import FormError from 'core/gd-form/common/form-error/form-error'

import PrioritySelect from 'core/gd-form/form-element/priority-select/priority-select'
// import SelectorComponent from 'core/gd-components/selector/selector'
// import OptionComponent from 'core/gd-components/selector/option-components/user-icon/user-icon-small'

class ModalActionPriority extends React.Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        companyId: PropTypes.string.isRequired,
        projectId: PropTypes.string,
    }

    constructor(props) {
        super(props);

        const initFormData = {
            priority: null,
            user: null
        };

        const formStructure = {
            fields: {
                priority: {
                    type: 'select',
                    isRequired: false
                },
                user: {
                    type: 'select',
                    isRequired: false
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    componentDidMount() {
        this.form.onFormComponentValueChange("priority",5);
        this.forceUpdate();
    }

    onSubmit = (result) => {
        this.props.onSubmit(result);
    }

    onPrioritySelect = (newValue, confirmCallback) => {
        this.form.onFormComponentValueChange('priority',newValue);
        if (confirmCallback) confirmCallback(newValue);

        if (newValue === gd.const.priority.levels.emergency || newValue === gd.const.priority.levels.blocker) {
            this.form.setFieldIsRequired('user', true);
        } else {
            this.form.setFieldIsRequired('user', false);
            this.form.onFormComponentValueChange('user',null);
        }

        this.forceUpdate();
    }

    /*onUserSelectorChange = (userId) => {
        this.form.onFormComponentValueChange('user',userId);
        this.forceUpdate();
    }*/

    render() {
        let priorityOptions = gd.session.companies.get(gd.companyId).priorities.exportToOptions();
        /*let projectUsers = [];
        if (this.props.projectId) {
            projectUsers = gd.session.projectUsers.filterByProject(this.props.projectId);
            projectUsers = projectUsers.exportToOptions();
        }*/

        // const selectedPriority = this.form.getValue("priority");
        // const showUserSelection = selectedPriority === gd.const.priority.levels.emergency || selectedPriority === gd.const.priority.levels.blocker;

        return (
            <Form form={this.form} submitLabel="Save" >
                <div className="tbl">
                    <div className="row">
                        <div className="label"/>
                        <div className="element">
                            <PrioritySelect form={this.form}
                                            className="priority"
                                            name="priority"
                                            priorityOptions={priorityOptions}
                                            onPrioritySelect={this.onPrioritySelect}
                                            noEmergency={true}
                                            noBlocker={true}
                                            attachment="top center"
                                            targetAttachment="bottom center"
                                            targetOffset="0 0"/>
                        </div>

                    </div>
                    {/*{showUserSelection &&
                    <div className="row">
                        <div className="row-title">Please select a user who has to take an action</div>
                        <div className="label">User</div>
                        <div className="element">
                            <SelectorComponent value={null}
                                               optionComponent={OptionComponent}
                                               options={projectUsers}
                                               className="selector-user"
                                               onChange={this.onUserSelectorChange} />
                        </div>

                        <FormError form={this.form} name="user"/>
                        <div className="cf"> </div>
                    </div>}*/}
                </div>
            </Form>
        );
    }
}

module.exports = ModalActionPriority;